import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalHeader.vue?vue&type=template&id=7faa7526&"
import script from "./AssessmentGlobalSingleTaskModalHeader.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports